























































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "../root/modal";
import { CopyUrl } from "@/common/clipboard";

export default Vue.extend({
  props: ["modalData"],
  components: {
    Modal,
  },
  setup() {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "50rem",
      withTopRightCloseBtn: true,
    };

    const copy_value = (key: string, val: string) => {
      CopyUrl(val, `${key} copied to clipboard`);
    };

    return {
      copy_value,
      config,
    };
  },
});
